<template>
  <testdata-menu :menu-elements='menuElements' @toggle-active-menu="toggleActiveMenu"></testdata-menu>
  <testdata-main :active-page="activePage"></testdata-main>
</template>

<script>
import TestdataMenu from "./components/Menu.vue";
import TestdataMain from "./components/Main.vue";

export default {
  name: 'App',
  components: {
    TestdataMenu,
    TestdataMain
  },
  data() {
    return {
      activePage: 'personnummer',
      menuElements: [
        { name: 'personnummer', label: 'Personnummer', active: true },
        { name: 'kontonummer', label: 'Bank', active: false },
        { name: 'person', label: 'Telefonnummer', active: false }
      ]
    }
  },
  methods: {
    toggleActiveMenu(name){
      this.menuElements.forEach((it) => {
        it.active = it.name === name
      })
      this.activePage = name
    }
  }
}
</script>

<style>

html, body {
  min-height: 100%;
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  margin-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 60px;
  line-height: 60px; /* Vertically center the text there */
  background-color: #f5f5f5;
}


/* Custom page CSS
-------------------------------------------------- */
/* Not required for template or sticky footer method. */

body > .container {
  padding: 60px 15px 0;
}

.footer > .container {
  padding-right: 15px;
  padding-left: 15px;
}

code {
  font-size: 80%;
}

</style>

